import Image from "next/image"

import { AssetProps } from "./types"

export function RundooLogo(props: AssetProps) {
  return <Image src="/wordmark-blue.svg" alt="Rundoo Logo" {...props} />
}
